var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesignHome = function SvgDesignHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M26.246 80C6.111 57.321 5 36 5 36s20.253 7.466 33 44zM103.715 80C123.888 57.321 125 36 125 36s-20.253 7.466-33 44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M96.333 26.973H17.291v2.274h79.042zM76.583 0l-36.19 26.973H17.291L53.201 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#012A66",
    d: "M76.584 0v2.274l-36.19 26.933v-2.235z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M73.51 2.273H53.36v15.003l-11.651 8.618V79.96h63.561V25.894z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "m53.359 2.273-31.8 23.621V79.96h63.56V25.894z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M61.94 44.129H44.741v35.87H61.94z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#024390",
    d: "m53.361 2.273 36.19 26.933h23.102L76.743 2.273z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "m53.361 0 36.19 26.973h23.102L76.743 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0075C9",
    d: "M53.361 0v2.274l36.19 26.933v-2.235zM112.653 26.973H89.551v2.274h23.102z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M77.063 46.004H70.16v15.042h6.903z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M81.33 44.129h-4.308v16.918h4.309zM70.12 44.129h-4.31v16.918h4.31z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M70.16 55.062V44.129h4.788v6.145a4.8 4.8 0 0 1-4.788 4.788"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M77.022 55.062V44.129h-4.788v6.145a4.8 4.8 0 0 0 4.788 4.788"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M98.928 46.004h-6.903v15.042h6.903z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0075C9",
    d: "M103.235 44.129h-4.31v16.918h4.31zM92.024 44.129h-4.31v16.918h4.31z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M92.023 55.062V44.129h4.788v6.145a4.776 4.776 0 0 1-4.788 4.788"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M98.925 55.062V44.129h-4.788v6.145a4.8 4.8 0 0 0 4.788 4.788"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M36.762 45.127H29.86v15.92h6.903z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M41.07 44.129h-4.308v16.918h4.309zM29.819 44.129h-4.31v16.918h4.31z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M29.86 55.062V44.129h4.787v6.145a4.8 4.8 0 0 1-4.788 4.788"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M36.761 55.062V44.129h-4.788v6.145c-.04 2.633 2.115 4.788 4.788 4.788"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M61.94 37.107H44.741v4.03H61.94z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M59.545 64.08a1.037 1.037 0 1 0 0-2.074 1.037 1.037 0 0 0 0 2.075"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4EFFC",
    strokeMiterlimit: 10,
    d: "M23.635 30.565h58.613M52.322 46.723h-5.387V59.29h5.387zM59.547 46.723H54.16V59.29h5.387zM53.36 23.98a4.509 4.509 0 1 0 0-9.017 4.509 4.509 0 0 0 0 9.017Z"
  })));
};
export default SvgDesignHome;